<template>
    <div
        class="component site-header"
        :class="{ 'is-collapsed': !isBrandbarExpanded, 'is-collapsed-no-anim': isBrandImmediatelyCollapsed }"
    >
        <div class="wrapper wrapper-large">
            <router-link to="/" v-if="!isHome">
                <div class="logo-container" :class="`color-scheme-${logoColorScheme}`">
                    <svg class="logo-shape" viewBox="0 0 174 128">
                        <g id="1T1_logo_rgb_n-(1)" transform="translate(79.000000, 26.000000)" fill="#FFFFFF" fill-rule="nonzero">
                            <path d="M5.23809524,17.16 L0,17.16 L0,11.96 L5.23809524,11.96 L5.23809524,17.16 Z M0,0 L0,8.84 L1.57142857,8.84 L1.57142857,8.58 C1.57142857,4.42 3.92857143,1.82 8.38095238,1.82 L8.64285714,1.82 L8.64285714,20.54 C8.64285714,23.14 7.5952381,24.18 4.97619048,24.18 L4.19047619,24.18 L4.19047619,26 L17.8095238,26 L17.8095238,24.18 L17.0238095,24.18 C14.4047619,24.18 13.3571429,23.14 13.3571429,20.54 L13.3571429,1.82 L13.6190476,1.82 C18.0714286,1.82 20.4285714,4.42 20.4285714,8.58 L20.4285714,8.84 L22,8.84 L22,0 L0,0 Z M16.7619048,17.16 L22,17.16 L22,11.96 L16.7619048,11.96 L16.7619048,17.16 Z" id="Shape"></path>
                        </g>
                    </svg>
                    <svg class="logo" viewBox="0 0 174 128">
                        ">
                        <path d="m95.8 37.4h5v5h-5z" />
                        <path d="m80.1 37.4h5v5h-5z" />
                        <path
                            d="m80.4 25.2-.3 9.1 1.3.2c.3-2.6 1-4.6 2.1-5.9 1.2-1.3 3-2.1 5.1-2.1v18.9c0 1.7-.4 2.7-.9 3.2-.4.4-1 .7-2 .8-.3 0-.7 0-1.4 0v1.5h12.1v-1.5c-.7 0-1.1 0-1.4 0-1-.1-1.6-.3-2-.8-.5-.5-.9-1.6-.9-3.2v-18.9c2.1.1 4 .8 5.1 2.1s1.8 3.2 2.1 5.9l1.3-.2-.2-9.1z"
                        />
                    </svg>
                </div>
            </router-link>
            <a href="#opener" v-if="isHome">
                <div class="logo-container" :class="`color-scheme-${logoColorScheme}`">
                    <svg class="logo-shape" viewBox="0 0 174 128">
                        <path
                            ref="logoShape"
                            d="M41.1,0.4h92c0,0,21,12,20,36c-1.2,29.7-52,51-77,51c-26,0-48-21-48-48C28.1,10.4,41.1,0.4,41.1,0.4z"
                        />
                    </svg>
                    <svg class="logo" viewBox="0 0 174 128">
                        <g id="1T1_logo_rgb_n-(1)" transform="translate(79.000000, 26.000000)" fill="#FFFFFF" fill-rule="nonzero">
                            <path d="M5.23809524,17.16 L0,17.16 L0,11.96 L5.23809524,11.96 L5.23809524,17.16 Z M0,0 L0,8.84 L1.57142857,8.84 L1.57142857,8.58 C1.57142857,4.42 3.92857143,1.82 8.38095238,1.82 L8.64285714,1.82 L8.64285714,20.54 C8.64285714,23.14 7.5952381,24.18 4.97619048,24.18 L4.19047619,24.18 L4.19047619,26 L17.8095238,26 L17.8095238,24.18 L17.0238095,24.18 C14.4047619,24.18 13.3571429,23.14 13.3571429,20.54 L13.3571429,1.82 L13.6190476,1.82 C18.0714286,1.82 20.4285714,4.42 20.4285714,8.58 L20.4285714,8.84 L22,8.84 L22,0 L0,0 Z M16.7619048,17.16 L22,17.16 L22,11.96 L16.7619048,11.96 L16.7619048,17.16 Z" id="Shape"></path>
                        </g>
                    </svg>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    import anime from 'animejs/lib/anime.es.js';

    export default {
        name: 'SiteHeader',
        computed: {
            logoColorScheme() {
                return this.$store.getters.logoColorScheme;
            },
            isHome() {
                return this.$route.path === '/';
            },
            isBrandbarExpanded() {
                return this.$store.getters.isBrandbarExpanded;
            },
            isBrandImmediatelyCollapsed() {
                const routesWithCollapsedState = ['/imprint', '/privacy-policy'];
                return routesWithCollapsedState.includes(this.$route.path);

                /*
            if (routesWithCollapsedState.includes(this.$route.path)) {
                if (this.isBrandbarExpanded) {
                    setTimeout(() => {
                        this.$store.commit('collapseBrandbar');
                    }, 1000);
                }
            }

            */
            },
        },
        mounted() {
            this.applyCollapsedStateOnRoutes();
            document.querySelector('.logo-container').addEventListener('mouseenter', this.startLoop);
            document.querySelector('.logo-container').addEventListener('mouseleave', this.endLoop);
        },
        methods: {
            applyCollapsedStateOnRoutes() {
                const routesWithCollapsedState = ['/imprint', '/privacy-policy'];

                if (routesWithCollapsedState.includes(this.$route.path)) {
                    if (this.isBrandbarExpanded) {
                        setTimeout(() => {
                            this.$store.commit('collapseBrandbar');
                        }, 1000);
                    }
                }
            },
            startLoop() {
                anime.remove(this.$refs.logoShape);
                const timeline = anime.timeline({
                    loop: true,
                    autoplay: true,
                });

                timeline
                    .add({
                        targets: this.$refs.logoShape,
                        easing: 'linear',
                        d: [
                            {
                                value:
                                    'M41.1,0.4h92c0,0,11,14.7,10,38.7c-1.2,29.7-18.5,46.3-43.5,46.3c-26,0-77-23.8-77-50.8C22.5,5.7,41.1,0.4,41.1,0.4z',
                                duration: 500,
                                elasticity: 600,
                            },
                            {
                                value:
                                    'M41.1,0.4h92c0,0,31.6,19.7,30.6,43.7c-1.2,29.7-64.3,52.5-89.3,52.5c-26,0-59.7-10.4-59.7-37.4C14.7,30.2,41.1,0.4,41.1,0.4z',
                                duration: 2000,
                                elasticity: 600,
                            },
                        ],
                        direction: 'alternate',
                    })
                    .add({
                        targets: this.$refs.logoShape,
                        easing: 'linear',
                        d: [
                            {
                                value:
                                    'M41.1,0.4h92c0,0,21,12,20,36c-1.2,29.7-52,51-77,51c-26,0-48-21-48-48C28.1,10.4,41.1,0.4,41.1,0.4z',
                                duration: 2000,
                                elasticity: 600,
                            },
                        ],
                        direction: 'alternate',
                    });
            },
            endLoop() {
                anime.remove(this.$refs.logoShape);
                anime({
                    targets: this.$refs.logoShape,
                    duration: 1000,
                    elasticity: 600,
                    d:
                        'M41.1,0.4h92c0,0,21,12,20,36c-1.2,29.7-52,51-77,51c-26,0-48-21-48-48C28.1,10.4,41.1,0.4,41.1,0.4z',
                });
            },
        },
    };
</script>

<style scoped lang="scss">
    .site-header {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 2;
        height: 70px;
        pointer-events: none;

        @media (max-width: breakpoint('medium')) {
            height: 60px;
        }

        @media (max-width: breakpoint('small')) {
            height: 50px;
        }

        &:after {
            position: absolute;
            content: '';
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: color('magenta');
            z-index: -1;
        }

        &.is-collapsed {
            &:after {
                animation: anim-brand-bar-transition 0.3s 0s forwards;

                @keyframes anim-brand-bar-transition {
                    from {
                        // width: 100%;
                        height: 100%;
                    }

                    to {
                        // width: 0%;
                        height: 0%;
                    }
                }
            }

            .logo-shape {
                animation: anim-move-in-from-top 0.5s 0.25s forwards;

                @keyframes anim-move-in-from-top {
                    from {
                        transform: translateY(-100%);
                    }

                    to {
                        transform: translateY(-10%);
                    }
                }
            }
        }

        &.is-collapsed-no-anim {
            &:after {
                display: none;
            }

            .logo-shape {
                transform: translateY(-10%);
                animation: none;
            }
        }
    }

    .logo-container {
        transform: translate(-18%, -2px);
        width: 200px;
        display: inline-block;
        pointer-events: all;

        svg {
            width: 100%;
        }

        rect,
        path {
            transition: fill 0.5s;
        }

        .logo {
            position: relative;
            z-index: 2;
            transform: translateY(-8px);
            transition: transform 0.5s 0.5s;
        }

        .logo-shape {
            position: absolute;
            left: 0;
            top: 0;
            transform: translateY(-100%);
        }

        @media (max-width: breakpoint('medium')) {
            width: 175px;
        }

        @media (max-width: breakpoint('small')) {
            width: 150px;
        }

        &.color-scheme-default {
            .logo-shape {
                path {
                    fill: color('magenta');
                }
            }

            .logo {
                rect,
                path {
                    fill: #ffffff;
                }
            }
        }

        &.color-scheme-inverted {
            .logo-shape {
                path {
                    fill: #fff;
                }
            }

            .logo {
                rect,
                path {
                    fill: color('magenta');
                }
            }
        }
    }
</style>
